import React, { useEffect,useRef, useState } from "react"
import  secureLocalStorage  from  "react-secure-storage";
import { teamTimerConverter } from "../../utils/utils";
import { WebsocketContext } from "../../websocket/context";
import { useContext } from "react";




function TimerFunction({type,total_hour,total_minutes}){

    const [ready, val, send] = useContext(WebsocketContext); 

    if(type === "team"){
        let [hour,minutes,second] = teamTimerConverter(total_hour,total_minutes)
        total_hour = hour
        total_minutes = minutes
        second = second

    }
    const hour = parseInt(total_hour)
    const minutes = parseInt(total_minutes)
    const [pause,setPause] = useState(false);
    useEffect(()=>{
        const temp = JSON.parse(val)
        if(temp.action === 'timer'){
            secureLocalStorage.setItem("started",temp.data.pause)
            setPause(secureLocalStorage.getItem("started"))
        }
    },[val])



    var s =0
    var m = 0
    var h = 0
    var max = 59
    const checkValue = (value) => {
            if (value < 10) {
                value = '0'+parseInt(value)
                return value;
            } else {
                return value;
            }
        }

    const timer_html_attr=(pause)=>{
        const oneSec = 1000
        const container = document.getElementById('timer');
        
        while (container.hasChildNodes()){
            container.firstChild.remove()
        };
        let dataHours = secureLocalStorage.getItem("hour") ? checkValue(secureLocalStorage.getItem("hour")):container.getAttribute('data-hours')
        let dataMinutes = secureLocalStorage.getItem("min") ? checkValue(secureLocalStorage.getItem("min")):container.getAttribute('data-minutes')
        let dataSeconds = secureLocalStorage.getItem("sec") ? checkValue(secureLocalStorage.getItem("sec")):container.getAttribute('data-seconds')
        let timerEnd = container.getAttribute('data-timer-end')
        let timerOnEndMsg = "data-timer-end";
        

        if (dataHours == '' || dataHours == null || dataHours == NaN) {
            dataHours = "0";
        }
        if (dataMinutes == '' || dataMinutes == null || dataMinutes == NaN) {
            dataMinutes = "0";
        }
        if (dataSeconds == '' || dataSeconds == null || dataSeconds == NaN) {
            dataSeconds = "0";
        }

        
        var hoursSpan = document.createElement('span')
        hoursSpan.id = "span_hour"
        var minutesSpan = document.createElement('span')
        minutesSpan.id = "span_minutes"
        var secondsSpan = document.createElement('span')
        secondsSpan.id = "span_seconds"
        var separator1 = document.createElement('span')
        separator1.id = "span_separator_1"
        var separator2 = document.createElement('span')
        separator2.id = "span_separator_2"

    
        let separatorValue = ":"
        let max = 59,


        s = parseInt(dataSeconds) > max ? max : parseInt(dataSeconds),
        m = parseInt(dataMinutes) > max ? max : parseInt(dataMinutes),
        h = parseInt(dataHours);


        secondsSpan.classList.add('time');
        minutesSpan.classList.add('time');
        hoursSpan.classList.add('time');
        separator1.classList.add('separator');
        separator1.textContent = separatorValue;
        separator2.classList.add('separator');
        separator2.textContent = separatorValue;

        hoursSpan.textContent =  checkValue(dataHours);
        minutesSpan.textContent =  checkValue(dataMinutes);
        secondsSpan.textContent = checkValue(dataSeconds);

        let children = [hoursSpan, separator1, minutesSpan, separator2, secondsSpan];

        for (let child of children) {
            container.appendChild(child);
        }
       
    
    const timer = function (sv, mv, hv) {
            s = parseInt(sv);
            m = parseInt(mv);
            h = parseInt(hv);
        
            if (s > 0) {
                return s -= 1;
            } else {
                s = max;
                if (m > 0) {
                    return m -= 1;
                } else {
                    m = max;
                    if (h > 0) {
                        return h -= 1;
                    }
                }
            }
        }
    const finished = () => {
        max = 0;
        let timerEnd = container.getAttribute(timerOnEndMsg);
        container.setAttribute(timerOnEndMsg, "You're done!");
        if (timerEnd == '' || timerEnd == null) {
            container.textContent = "You're done!";
        } else {
            container.textContent = timerEnd;
        }
    }
    const counter = setInterval(() => {
        if(secureLocalStorage.getItem("started")){
            if (h == 0 && m == 0 && s == 0) {
                clearInterval(counter, finished());
            }

            if (s >= 0) {
                    timer(s, m, h);
                    secureLocalStorage.setItem('hour',checkValue(h))
                    secureLocalStorage.setItem('min',checkValue(m))
                    secureLocalStorage.setItem('sec',checkValue(s))

                    hoursSpan.textContent = checkValue(h);
                    minutesSpan.textContent = checkValue(m);
                    secondsSpan.textContent = checkValue(s);
            }
        }
        }, oneSec);
    
    }
            

    
    useEffect(()=>{
        return()=>{
            if(document.getElementById("timer")){
                timer_html_attr()
            }

        }
    },[pause])

    return(
        <>
            <div id="timer" className="timer" data-hours={hour} data-minutes={minutes} data-seconds='0'>
            </div>

        </>
 
    );
}

export default TimerFunction